import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=ac54d0bc&scoped=true"
import script from "./SettingsNav.vue?vue&type=script&lang=js"
export * from "./SettingsNav.vue?vue&type=script&lang=js"
import style0 from "./SettingsNav.vue?vue&type=style&index=0&id=ac54d0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac54d0bc",
  null
  
)

export default component.exports